
import { useState, useEffect, useCallback } from 'react';
import { DealerManager } from '@/utils/dealerManager';

export const useTradeEstimate = () => {
  // Initialize to false - only show when dealer config confirms it's enabled
  const [isTradeEstimateEnabled, setIsTradeEstimateEnabled] = useState(false);
  const [isTradeEstimateVisible, setIsTradeEstimateVisible] = useState(false);

  // Check dealer's trade_banner_enabled setting on mount and when config changes
  useEffect(() => {
    const checkTradeBannerSetting = () => {
      // Respect the dealer's trade_banner_enabled setting from DealerManager cache
      const isBannerEnabled = DealerManager.isTradeBannerEnabled();
      
      setIsTradeEstimateEnabled(isBannerEnabled);
      setIsTradeEstimateVisible(isBannerEnabled);
    };

    // Check immediately
    checkTradeBannerSetting();
    
    // Also check after a short delay to catch late-loading dealer config
    const timeoutId = setTimeout(checkTradeBannerSetting, 500);
    
    return () => clearTimeout(timeoutId);
  }, []);

  // These are memoized because consumers list them in useEffect dependency
  // arrays (e.g. the "hide trade estimate when a form is active" effects in
  // ChatLayoutDesktop/ChatLayoutMobile). As bare arrows they changed identity on
  // every render, which re-ran those effects after every commit.
  const showTradeEstimate = useCallback(() => {
    // Only allow showing if dealer has it enabled
    if (DealerManager.isTradeBannerEnabled()) {
      setIsTradeEstimateVisible(true);
    }
  }, []);

  const hideTradeEstimate = useCallback(() => {
    setIsTradeEstimateVisible(false);
  }, []);

  const toggleTradeEstimate = useCallback(() => {
    setIsTradeEstimateEnabled(prevEnabled => {
      if (!prevEnabled && DealerManager.isTradeBannerEnabled()) {
        setIsTradeEstimateVisible(true);
        return true;
      }
      return !prevEnabled;
    });
  }, []);

  return {
    isTradeEstimateEnabled,
    isTradeEstimateVisible,
    showTradeEstimate,
    hideTradeEstimate,
    toggleTradeEstimate,
  };
};
